<template>
  <div class="kye-dialog-body">
    <kye-form label-position="right"
              :model="queryData"
              inline
              ref="queryform">
      <kye-form-item label="被借人"
                     prop="borrowUserName">
        <kye-search-tips v-model="queryData.borrowUserName"
                         url="data.employee.listByName"
                         value-key="chineseName"
                         clearable
                         :keys="['chineseName', 'position','departmentName','employeeNumber']"
                         :format-data="formatEmployeeName"
                         style="width: 150px"
                         placeholder="请输入姓名/工号"
                         @clear="clearEmployeeName"
                         @select="selectEmployeeName">
        </kye-search-tips>
      </kye-form-item>
      <kye-form-item label-width="0px">
        <kye-button type="primary"
                    hotkey="ctrl+s"
                    auth="BToOe0ySNoBx"
                    @click="getListData">查询</kye-button>
      </kye-form-item>
    </kye-form>
    <kye-button @click="goPage"
                type="text"><i class="layout layout-quanxianshenqing"></i>账号申请</kye-button>
    <table-list :data="tableData"
                :column="column"
                :options="options"
                dialog
                :operation="operation"
                @sort-change="onSortChange"/>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        queryData: {},
        tableData: [],
        options: {
          sortType: 'auto',
        },
        column: [
          {
            label: '设备',
            key: 'assetsCode',
            width: 120,
            show: true,
            sortKeys: ['assetsCode', 'assetsCode']
          },
          {
            label: '借用账号',
            key: 'borrowUserName',
            width: 80,
            show: true,
            sortKeys: ['borrowUserName', 'borrowUserName']
          },
          {
            label: '工号',
            key: 'borrowUserNumber',
            width: 80,
            show: true,
            sortKeys: ['borrowUserNumber', 'borrowUserNumber']
          },
          {
            label: '岗位',
            key: 'borrowUserDutyName',
            width: 110,
            show: true,
            sortKeys: ['borrowUserDutyName', 'borrowUserDutyName']
          },
          {
            label: '组织',
            key: 'borrowUserDeptName',
            width: 125,
            show: true,
            sortKeys: ['borrowUserDeptName', 'borrowUserDeptName']
          },
          {
            label: '有限期',
            key: 'effectiveTimeName',
            width: 80,
            show: true,
            sortKeys: ['effectiveTime', 'effectiveTime']
          },
          {
            label: '首次登录时间',
            key: 'firstLoginTime',
            filter: 'time',
            width: 140,
            show: true,
            sortKeys: ['firstLoginTime', 'firstLoginTime']
          },
          {
            label: '到期时间',
            key: 'expireDate',
            width: 125,
            filter: 'time',
            show: true,
            sortKeys: ['expireDate', 'expireDate']
          },
          {
            label: '查看模块',
            key: 'menuInfo',
            width: 150,
            show: true,
            sortKeys: ['menuInfo', 'menuInfo']
          },
        ],
        operation: {
          label: '操作',
          fixed: 'left',
          width: 100,
          options: [
            {
              type: 'button',
              label: '登录',
              auth: 'BToOe0ySN4bc',
              disabled: row => this.checkExpireDate(row),
              func: row => {
                if (!this.checkExpireDate(row)) {
                  this.getToken(row)
                } else {
                  this.$message.error('该账号借用时间已到期')
                }
              }
            },
            {
              type: 'button',
              label: '再次借用',
              auth: 'BToOe0ySN4bc',
              disabled: row => !this.checkExpireDateByBorrowing(row),
              func: row => {
                if (this.checkExpireDateByBorrowing(row)) {
                  this.goPageBorrowingDetail(row)
                }
              }
            },
          ]
        }
      }
    },
    created () {
      this.getListData()
    },
    methods: {
      onSortChange (val) {
        this.sortObj = val
        this.sort()
      },
      sort () {
        let prop = this.sortObj.prop
        const order = this.sortObj.order
        if (!prop || !order) return
        if (prop === 'effectiveTimeName') prop = 'effectiveTime'
        this.tableData.sort((a, b) => {
          if (order === 'ascending') {
            return ['effectiveTime'].includes(prop) ? (+a[prop]) - (+b[prop]) : a[prop].localeCompare(b[prop])
          } else {
            return ['effectiveTime'].includes(prop) ? (+b[prop]) - (+a[prop]) : b[prop].localeCompare(a[prop])
          }
        })
      },
      async getListData () {
        let res = await this.$http('auth.business.authApplyBorrowAccount.list', this.queryData,
          {
            axios: {
              headers: { 'X-menu-id': '2820215716730110' }
            }
          }
        )
        this.tableData = res
      },
      /**
       * 获取 token
       */
      async getToken (row) {
        let url = window.location.origin
        let token = await this.$http('auth.business.authApplyBorrowAccount.getToken', {
          expireDate: row.expireDate,
          borrowUserId: this.$store.state.user.id,
          businessId: row.borrowUserId,
          appId: row.appId,
          assetsCode: row.assetsCode
        }, {
          axios: {
            headers: { 'X-menu-id': '2820215716730110' }
          }
        })
        token = window.btoa(token)
        window.open(`${url}/#/?isExpired=1&erpticket=${token}`, '_blank', 'noopener')
      },
      clearEmployeeName () {
        this.queryData.borrowUserId = ''
        this.queryData.borrowUserName = ''
      },
      selectEmployeeName (data) {
        this.queryData.borrowUserName = data.chineseName
        this.queryData.borrowUserId = data.id
      },
      /**
       * 登录-校验时间是否过期&是否在职
       */
      checkExpireDate (data) {
        const {expireDate, inOffice} = data
        return Number(inOffice) !== 10 || (expireDate && (+new Date()) > expireDate)
      },
      /**
       * 再次借用-校验时间是否过期&是否在职
       */
      checkExpireDateByBorrowing(data) {
        const {expireDate, inOffice} = data
        return Number(inOffice) === 10 && (expireDate && (+new Date()) > expireDate)
      },
      /**
       * 格式化
       */
      formatEmployeeName (val) {
        let data = null
        if (/^\d{6,}$/.test(val)) {
          data = { employeeNumber: val, status: '10' }
        } else if (!/^\d+$/.test(val)) {
          data = { chineseName: val, status: '10' }
        }
        return data
      },
      // 再次借用-新增
      goPage () {
        this.$router.push('/oa/workflow/new-application/QXSQ-0003?activeTab=third&operationType=80')
        this.$emit('close')
      },
      // 再次借用-编辑
       goPageBorrowingDetail (row) {
        console.log('goPageDetail=====>', row)
        this.$router.push(`/oa/workflow/new-application/QXSQ-0003?formId=${row.applyId}&activeTab=third&operationType=80`)
        this.$emit('close')
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/layout/components/account-list-dialog.vue